var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("g", [
    _c("defs", [
      _c("path", {
        attrs: {
          id: "attention@1x-a",
          d:
            "M11.9796466,15.3564569 C11.530413,15.3564569 11.1662373,15.7178609 11.1662373,16.1636752 C11.1662373,16.6094896 11.530413,16.9708936 11.9796466,16.9708936 C12.4288801,16.9708936 12.7930558,16.6094896 12.7930558,16.1636752 C12.7930558,15.7178609 12.4288801,15.3564569 11.9796466,15.3564569 Z M20.6587234,16.5430679 L14.1107788,5.24201099 C13.6798062,4.47522714 12.8643771,4 11.9796466,4 C11.094916,4 10.2794869,4.47522714 9.84851429,5.24201099 L3.34124019,16.5430679 C2.89553291,17.2890375 2.8858175,18.214586 3.31576898,18.9696079 C3.74572046,19.7246299 4.54969236,20.1938461 5.4235679,20.1998851 L18.5357252,20.1998851 C19.4168693,20.2083844 20.2342503,19.7448943 20.6741613,18.9871817 C21.1140723,18.2294692 21.1081714,17.2952481 20.6587234,16.5430679 Z M19.2515253,18.1575046 C19.1063158,18.4138934 18.8320818,18.5716148 18.5357252,18.5692136 L5.4235679,18.5692136 C5.1272113,18.5716148 4.85297733,18.4138934 4.70776775,18.1575046 C4.56246618,17.9077503 4.56246618,17.6000404 4.70776775,17.3502862 L11.2150418,6.04922934 C11.3542129,5.77964568 11.63375,5.6100707 11.9389761,5.6100707 C12.2442022,5.6100707 12.5237393,5.77964568 12.6629103,6.04922934 L19.2108549,17.3502862 C19.3752488,17.5966652 19.3908494,17.9124951 19.2515253,18.1736489 L19.2515253,18.1575046 Z M11.9796466,8.89871011 C11.530413,8.89871011 11.1662373,9.26011407 11.1662373,9.70592846 L11.1662373,12.9348018 C11.1662373,13.3806162 11.530413,13.7420202 11.9796466,13.7420202 C12.4288801,13.7420202 12.7930558,13.3806162 12.7930558,12.9348018 L12.7930558,9.70592846 C12.7930558,9.26011407 12.4288801,8.89871011 11.9796466,8.89871011 Z"
        }
      })
    ]),
    _vm._v(" "),
    _c("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [
      _c("rect", {
        staticStyle: { "mix-blend-mode": "color-burn" },
        attrs: {
          width: "24",
          height: "24",
          fill: "#E3E3E3",
          "fill-opacity": ".01"
        }
      }),
      _vm._v(" "),
      _c("use", {
        attrs: {
          fill: _vm.currentColor,
          opacity: _vm.opacity,
          "fill-rule": "nonzero",
          "xlink:href": "#attention@1x-a"
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }